// @ts-expect-error: Unchecked type import
import { Login } from "./Login";
// @ts-expect-error: Unchecked type import
import { Logout } from "./Logout";
import LoginPage from "../../pages/Login";
import {
  ApplicationPaths,
  LoginActions,
  LogoutActions,
} from "./AuthorizationConstants";

const AuthorizationRoutes = [
  {
    path: "/Account/Login",
    element: <LoginPage />,
  },
  {
    path: ApplicationPaths.Login,
    element: loginAction(LoginActions.Login),
  },
  {
    path: ApplicationPaths.LoginFailed,
    element: loginAction(LoginActions.LoginFailed),
  },
  {
    path: ApplicationPaths.LoginCallback,
    element: loginAction(LoginActions.LoginCallback),
  },
  {
    path: ApplicationPaths.Profile,
    element: loginAction(LoginActions.Profile),
  },
  {
    path: ApplicationPaths.Register,
    element: loginAction(LoginActions.Register),
  },
  {
    path: ApplicationPaths.LogOut,
    element: logoutAction(LogoutActions.Logout),
  },
  {
    path: ApplicationPaths.LogOutCallback,
    element: logoutAction(LogoutActions.LogoutCallback),
  },
  {
    path: ApplicationPaths.LoggedOut,
    element: logoutAction(LogoutActions.LoggedOut),
  },
];

function loginAction(name: string) {
  return <Login action={name}></Login>;
}

function logoutAction(name: string) {
  return <Logout action={name}></Logout>;
}

export default AuthorizationRoutes;
